import {
  ClearIcon,
  ArrowBackIosIcon,
  ArrowForwardIosIcon,
} from '@weblite/icons'
import { IconButton, styled } from '@mui/material'
import { RefObject } from 'react'
import { StoryViewerActionsApi } from '$comp/_app/components/story/peer-story-viewer/peer-story-viewer'
import { closeStory } from '$logic/router'

export function DesktopModeActionButtons({
  actionRef,
}: {
  actionRef: RefObject<StoryViewerActionsApi>
}) {
  return (
    <>
      <CloseButtonWrapper>
        <ActionButton
          size="medium"
          onClick={closeStory}
          data-test-id="desktop-mode-action-buttons-close-button"
        >
          <ClearIcon />
        </ActionButton>
      </CloseButtonWrapper>

      <PrevButtonWrapper>
        <ActionButton
          size="medium"
          onClick={() => actionRef.current?.onBack()}
          data-test-id="desktop-mode-action-buttons-prev-button"
        >
          <ArrowBackIosIcon />
        </ActionButton>
      </PrevButtonWrapper>

      <NextButtonWrapper>
        <ActionButton
          size="medium"
          onClick={() => actionRef.current?.onForward()}
          data-test-id="desktop-mode-action-buttons-next-button"
        >
          <ArrowForwardIosIcon />
        </ActionButton>
      </NextButtonWrapper>
    </>
  )
}

const Root = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
`

const CloseButtonWrapper = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
`

const PrevButtonWrapper = styled('div')`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  left: 0;
`

const NextButtonWrapper = styled('div')`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  right: 0;
`

const ActionButton = styled(IconButton)`
  background-color: ${({ theme }) => theme.palette.neutral1000};
  color: ${({ theme }) => theme.palette.neutral000};
  z-index: 1;
  &:hover {
    background-color: ${({ theme }) => theme.palette.neutral1000};
  }
`
